import { Autocomplete, paletteHelper, spacingHelper, typographyHelper } from '@construct-kit/core';
import styled, { css } from 'styled-components';

export const dangerouslySetClassNames = {
  textInputAndListboxContainer: 'InputListboxContainer',
  inputBorder: 'InputBorder',
  listboxWrapper: 'ListboxWrapper',
  listbox: 'Listbox',
  listboxOption: 'ListboxOption',
  scrollableArea: 'InputContainer',
};

export const StyledLocationSuggest = styled(Autocomplete)<{
  showRecentSearches: boolean;
}>`
  .${dangerouslySetClassNames.inputBorder} {
    ::after {
      border: none;
    }
  }

  .${dangerouslySetClassNames.inputBorder}:focus-within {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
  }

  .${dangerouslySetClassNames.listbox} {
    max-height: 100%;
    border: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
  }

  .${dangerouslySetClassNames.listboxOption} div {
    display: flex;
    align-items: center;
  }

  ${({ showRecentSearches }) =>
    (showRecentSearches
      ? css`
          .${dangerouslySetClassNames.listbox}:before {
            content: 'Recent Locations';
            display: block;
            padding: ${spacingHelper('large medium small')};
            ${typographyHelper('overline')}
          }
        `
      : css`
          .${dangerouslySetClassNames.listbox}:before {
            content: 'Location Suggestions';
            display: block;
            padding: ${spacingHelper('large medium small')};
            ${typographyHelper('overline')}
          }

          .${dangerouslySetClassNames.listboxOption}:last-child:before {
            content: 'Search for:';
            margin-right: ${spacingHelper('small')};
          }

          .${dangerouslySetClassNames.listboxOption}:last-child {
            svg {
              display: none;
            }
          }
        `)}
`;

export const modalSingleLocationSuggestStyles = css`
  .${dangerouslySetClassNames.textInputAndListboxContainer} {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .${dangerouslySetClassNames.inputBorder} {
    ::after {
      border: none;
      border-radius: 0;
      border-bottom: ${({ theme }) => theme.border.width.thin} solid
        ${paletteHelper('borderSecondary')};
    }
  }

  .${dangerouslySetClassNames.listboxWrapper} {
    top: 0;
    overflow: auto;
    position: relative;
    transform: none;
    padding: 0;
  }

  .${dangerouslySetClassNames.scrollableArea} {
    padding: ${spacingHelper('medium medium twoExtraSmall 0')};
    overflow: hidden;
  }
`;
